<template>
	<v-container>
		<v-alert
			class="success-alert"
			:value="alert"
			outlined
			type="success"
			text
			elevation="3"
			transition="slide-y-transition"
		>
			{{ alertMsg }}
		</v-alert>
		<v-card class="pt-1">
			<div class="d-flex justify-space-between">
				<div class="text-h4 mx-5 my-3 font-weight-bold">{{ title }}</div>
				<div class="my-auto">
					<v-btn v-if="mode==1" class="my-auto mr-2" color="error" large @click="clickDelete">削除</v-btn>
					<v-btn class="my-auto mr-10" color="warning" large @click="clickBack">戻る</v-btn>
				</div>
			</div>
			<v-divider class="mx-3 mt-0 mb-5"></v-divider>
			<v-row dense>
				<v-col cols="2"></v-col>
				<v-col cols="8">
				<div class="mx-auto">
					<v-simple-table class="pa-15">
						<tr>
							<th>会社ID :</th>
							<td><span class="ml-5">{{ dispMemberId }}</span></td>
						</tr>
						<tr>
							<th>状態 :</th>
							<td>
								<v-radio-group
									v-model="status"
									row
									dense
									class="mx-2"
								>
									<v-radio
										v-for="(st, index) in statusList"
										:key="index"
										:label="st.label"
										:value="st.val"
									></v-radio>
								</v-radio-group>
							</td>
						</tr>
						<tr>
							<th>会社名 :</th>
							<td>
								<v-text-field
									v-model="memberName"
									dense
									outlined
									hide-details=""
									class="my-1 mx-2"
									style="width:500px"
									:error="errMsg.memberName.length>0"
								></v-text-field>
								<span v-show="errMsg.memberName.length>0" class="error-message ml-5">
									{{ errMsg.memberName[0] }}
								</span>
							</td>
						</tr>
						<tr>
							<th>事業場名 :</th>
							<td>
								<v-text-field
									v-model="workPlace"
									dense
									outlined
									hide-details=""
									class="my-1 mx-2"
									style="width:500px"
								></v-text-field>
							</td>
						</tr>
						<tr>
							<th style="vertical-align: top!important; padding-top: 0.5em">メールアドレス :</th>
							<td>
								<div v-for="(email, index) in emailList" :key="index" class="mb-2">
									<div class="d-flex align-center" style="width:500px;min-width:500px">
										<v-text-field
											v-model="emailList[index]"
											dense
											outlined
											hide-details=""
											class="my-1 mx-2"
											style="width:500px;min-width:500px"
											:error="errMsg.emails[index] && errMsg.emails[index].length>0"
											:placeholder="`メールアドレス${index + 1}`"
										></v-text-field>
										<v-btn
											v-if="emailList.length > 1"
											icon
											small
											@click="removeEmail(index)"
											color="error"
										>
											<v-icon>mdi-minus-circle</v-icon>
										</v-btn>
									</div>
									<v-btn
										v-if="index === emailList.length - 1 && emailList.length < 20"
										icon
										small
										@click="addEmail"
										color="primary"
										class="ml-1 mt-1"
									>
										<v-icon>mdi-plus-circle</v-icon>
									</v-btn>
									<span v-if="errMsg.emails[index] && errMsg.emails[index].length>0" class="error-message ml-5">
										{{ errMsg.emails[index][0] }}
									</span>
								</div>
							</td>
						</tr>
						<tr>
							<th>メール件名 :</th>
							<td>
								<v-text-field
									v-model="userSubject"
									dense
									outlined
									hide-details=""
									class="my-1 mx-2"
									style="width:500px"
								></v-text-field>
							</td>
						</tr>
						<tr>
							<th style="vertical-align: top!important;">メール設定欄 :</th>
							<td>
								<v-textarea
									v-model="mailTemplate"
									outlined
									class="my-1 mx-2"
									style="width:500px"
								></v-textarea>
							</td>
						</tr>
						<tr>
							<th style="vertical-align:top!important;">備考 :</th>
							<td>
								<v-textarea
									v-model="remarks"
									outlined
									class="my-1 mx-2"
									style="width:500px"
								></v-textarea>
							</td>
						</tr>

					</v-simple-table>
				</div>
				<div>
					<div class="mx-auto" style="width:100px">
						<v-btn x-large class="mb-10" @click="clickSave" color="info">保存</v-btn>
					</div>
				</div>
				</v-col>
				<v-col cols="2"></v-col>
			</v-row>
		</v-card>
		
	</v-container>
</template>

<style scoped>
th {
	width:140px;
	/* background-color:lightgray;
	border-top:1px solid #000;
	border-left:1px solid #000; */
	text-align: justify;
	text-align-last: justify;
	text-justify: inter-character;
}

.error-message {
	color:red;
	font-size:12px;
	margin-top:0px;
}

.success-alert {
	position: absolute;
	background-color: #fff!important;
	bottom: 20px;
	right:30px;
	left:auto;
	z-index: 1;
}
</style>

<script>
export default {
	name: 'MemberEdit',
	data(){
		return{
			mode: 0, // 0:新規 1:編集
			title:'',
			memberId: 0,
			status: 0,
			statusList:[{ label:'開始', val: 1 } , { label:'停止', val: 2 }],
			dispMemberId:'',
			memberName: '',
			workPlace:'',
			emailList: [''], // メールアドレスの配列
			userSubject:'',
			mailTemplate:'',
			remarks:'',
			errMsg: {
				memberName:[],
				emails:[], // メールアドレスエラーの配列
			},
			alert:false,
			alertMsg:'',
		}
	},
	mounted: function () {
		console.log(this.errMsg)
		this.mode = this.$route.params.mode;
		this.title = this.mode == 0? '新規登録':'編集';
		if(this.mode===1){
			this.memberId = this.$route.params.memberId;
			this.status = this.$route.params.status;
			this.memberName = this.$route.params.memberName;
			this.workPlace = this.$route.params.workPlace;
			
			// mailカラムからカンマ区切りで取得
			if(this.$route.params.mail) {
				this.emailList = this.$route.params.mail.split(',').filter(email => email.trim() !== '');
			} else {
				this.emailList = [''];
			}
			
			this.remarks = this.$route.params.remarks;
			this.userSubject = this.$route.params.userSubject;
			this.mailTemplate = this.$route.params.mailTemplate;
		}
		this.dispMemberId = this.mode == 0? '自動で採番されます':this.memberId;
	},
	methods: {
		addEmail: function() {
			if(this.emailList.length < 20) {
				this.emailList.push('');
			}
		},
		removeEmail: function(index) {
			if(this.emailList.length > 1) {
				this.emailList.splice(index, 1);
				// エラーメッセージも削除
				this.errMsg.emails.splice(index, 1);
			}
		},
		clickSave: function () {
			if(this.inputCheck())return

			// 空のメールアドレスを除外してカンマ区切りで送信
			const validEmails = this.emailList.filter(email => email.trim() !== '');
			
			const postData = {
				mode: this.mode,
				memberId: this.memberId,
				status: this.status,
				memberName: this.memberName,
				workPlace: this.workPlace,
				mail: validEmails.join(','), // カンマ区切りで送信
				user_subject: this.userSubject,
				mail_template: this.mailTemplate,
				remarks: this.remarks,
			}
			this.axios.post("update-member", postData).then((res)=> {
				console.log(res);
				this.alertMsg = '保存しました。'
				this.alert = true;
				setTimeout(() => {
					this.alert = false;
				}, 3000)
			})
		},
		clickBack: function () {
			this.$router.back();
		},
		clickDelete: async function () {
			// 確認メッセージ
			this.$swal({
				title: '確認',
				text: '削除してもよろしいですか？',
				allowOutsideClick: false,
				showConfirmButton: true,
				showCancelButton: true,
				confirmButtonText: "はい",
				cancelButtonText: "いいえ"
			}).then((result) => {
				if (result.isConfirmed) {
				/**はい */
				this.axios.post('delete-member',{ memberId: this.memberId })
				.then((res) => {
					console.log(res)

					this.alertMsg = '削除しました。'
					this.alert = true;
					setTimeout(() => {
						this.alert = false;
						this.$router.back();
					}, 3000)
				})
				return;
				}
				/**いいえ */
				return;
			})
		},
		inputCheck: function () {
			let errFlg = false;
			this.errMsg.memberName = [];
			this.errMsg.emails = [];

			if(this.memberName==''){
				this.errMsg.memberName.push("会社名を入力してください。");
				errFlg = true;
			}

			// メールアドレスのバリデーション
			const emailRegex = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
			let hasValidEmail = false;
			
			this.emailList.forEach((email, index) => {
				this.errMsg.emails[index] = [];
				if(email.trim() !== '') {
					if(!email.match(emailRegex)) {
						this.errMsg.emails[index].push("メールアドレスの形式が違います。");
						errFlg = true;
					} else {
						hasValidEmail = true;
					}
				}
			});

			// 少なくとも1つの有効なメールアドレスが必要
			if(!hasValidEmail) {
				if(this.errMsg.emails[0] === undefined) this.errMsg.emails[0] = [];
				this.errMsg.emails[0].push("少なくとも1つのメールアドレスを入力してください。");
				errFlg = true;
			}

			return errFlg;
		}
	}
}
</script>